function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_icon-calendar_211633",
  transform: "translate(-32 -32)"
}, React.createElement("path", {
  id: "Path_332",
  "data-name": "Path 332",
  d: "M45.959,64h-1.1v1.363a1.492,1.492,0,0,1-1.58,1.316,1.547,1.547,0,0,1-1.634-1.316V64H37.357v1.363a1.639,1.639,0,0,1-3.214,0V64h-1.1A1.017,1.017,0,0,0,32,64.984v11.97a1.008,1.008,0,0,0,1.041.974H45.959A1.009,1.009,0,0,0,47,76.951V64.984A1.017,1.017,0,0,0,45.959,64Zm-.566,11.916a.418.418,0,0,1-.429.4l-10.932,0a.427.427,0,0,1-.425-.408V68.162a.426.426,0,0,1,.445-.412h10.9a.422.422,0,0,1,.442.405Z",
  transform: "translate(0 -30.929)"
}), React.createElement("path", {
  id: "Path_333",
  "data-name": "Path 333",
  d: "M114.143,34.143a1.07,1.07,0,0,1-1.071,1.071h0A1.07,1.07,0,0,1,112,34.143V33.071A1.07,1.07,0,0,1,113.071,32h0a1.07,1.07,0,0,1,1.071,1.071Z",
  transform: "translate(-77.321)"
}), React.createElement("path", {
  id: "Path_334",
  "data-name": "Path 334",
  d: "M338.143,34.143a1.07,1.07,0,0,1-1.071,1.071h0A1.07,1.07,0,0,1,336,34.143V33.071A1.07,1.07,0,0,1,337.071,32h0a1.07,1.07,0,0,1,1.071,1.071Z",
  transform: "translate(-293.821)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/holiday.0e985cdf.svg";
export { SvgComponent as ReactComponent };